import React from "react";
import { FileObject, ResolvedFile } from "@citychallenge/common";
import { ResourceContext } from "./resource-context";

interface ResolveResourceImageProps {
  file: FileObject | undefined;
  onResolved: (image: ResolvedFile | undefined) => React.ReactElement;
}

class ResolveResourceImage extends React.PureComponent<ResolveResourceImageProps> {
  public static contextType = ResourceContext;
  public context!: React.ContextType<typeof ResourceContext>;

  public render() {
    const resolved = this.context.resolveFile(this.props.file);
    return this.props.onResolved(resolved);
  }
}

export const Resolve = {
  Image: ResolveResourceImage,
};
